module.exports = __webpack_public_path__ + "static/media/unnamed.ee39d341.png";